import React, {useContext} from 'react';
import {useNavigate} from 'react-router-dom';
import {signOut} from 'firebase/auth';

import {auth} from '-/firebase';
import {UserContext} from '-/contexts/User';
import {stationDisplayName} from '@embertracking/common';

import AppBanner from './AppBanner';

import HomeWorkIcon from '@mui/icons-material/HomeWork';

// Station logins are shared, deliberately limited accounts — no profile, no
// personal records, most member-only pages hidden (see Router/useMenuItems).
// Crews kept reading that as "my permissions are broken", so the session says
// what it is on every page. Deliberately NOT dismissible: the whole point is
// that it's still true an hour into the shift. Blue rather than the MFA
// banner's amber — this is context, not a warning.
export default function StationBanner() {
    const navigate = useNavigate();
    const {currentUser} = useContext(UserContext);
    const {isStation} = currentUser || {};

    if (!isStation) return null;

    const stationLabel = stationDisplayName(currentUser);

    const onSignOut = async () => {
        await signOut(auth);
        localStorage.removeItem('impersonating');

        navigate('/login');
    };

    return (
        <AppBanner
            tone="info"
            icon={<HomeWorkIcon />}
            action={{label: 'Sign In As Yourself', onClick: onSignOut, testId: 'station-banner-signout'}}
            testId="station-banner"
        >
            You&rsquo;re signed in as <strong>{stationLabel}</strong> &mdash; a shared account, so personal records and member-only pages aren&rsquo;t available.
        </AppBanner>
    );
}
